import gql from "graphql-tag";

export const SpecItemComment = gql`
  fragment SpecItemCommentFields on SpecItemComment {
    id
    content
    threadId
    hasParent
    status
    createdAt
    user {
      name
      currentUser
    }
  }
`;

export const fragments = {
  SpecItemComment
};
